<template>
  <!-- start 会员购买 -->
  <div class="dialog-box" v-if="open" @click="preventClick">
    <div class="members-buy" v-if="closeOne">
      <div class="members-buy-header">
        <div class="members-buy-header-title">会员购买</div>
        <div class="closed-container">
          <img
            class="members-buy-header-close"
            src="@/assets/images/white-close-icon.png"
            @click="closeWindows"
          />
        </div>
      </div>
      <div class="members-buy-header-activity">
        <div class="activity-label">限时大促</div>
        <span class="activity-title">新人限时特惠会员，超低到手价，速抢！</span>
      </div>
      <div class="members-buy-conent">
        <img
          class="members-buy-conent-left"
          src="@/assets/images/members-buy-conent-left.png"
        />
        <div class="members-buy-info">
          <div class="price-options">
            <div
              class="combo-list defalut-combo-list"
              v-for="(item, key) in comboList"
              @click="selectCombo(key)"
              :key="key"
              :class="[
                key > 0 ? 'combo-interval' : '',
                selectIndex == key ? 'select-combo-list' : '',
              ]"
            >
              <div class="combo-list-title">{{ item.plan_name }}</div>
              <div class="combo-list-price">
                <span style="font-size: 24px">￥</span>{{ item.price }}
              </div>
              <div class="combo-list-hint">
                <template v-if="key == 0">日常原价58.00</template>
                <template v-if="key == 1">日常原价86.00</template>
                <template v-if="key == 2">一次购买 终身可用</template>
              </div>
              <div class="combo-list-bottom">
                <template v-if="key == 0">一天1.2元体验</template>
                <template v-if="key == 1">仅0.6元/天</template>
                <template v-if="key == 2">仅0.01元/天</template>
              </div>
            </div>
          </div>
          <div class="members-buy-hint">
            温馨提示：VIP会员到期后将直接转为非会员状态，不会自动续费
          </div>
          <div class="qr-content">
            <div class="members-buy-scan-qr-codes">
              <div class="qr-vessel">
                <div class="load-vessel" v-if="isLoad" @click="refresh">
                  <!-- <img
                    class="load-vessel-icon"
                    src="@/assets/images/load-iocn.png"
                  /> -->
                  <div class="loading"></div>
                </div>
                <img class="qr-vessel-icon" :src="url" @load="isLoad = false" />
              </div>
              <div class="qr-vessel-info">
                <img
                  class="qr-vessel-info-icon"
                  src="@/assets/images/wx-icon.png"
                  style="margin-right: 6px"
                />
                <img
                  class="qr-vessel-info-icon"
                  src="@/assets/images/zfb-icon.png"
                  style="margin-right: 9px"
                />
                <span>扫码支付</span>
              </div>
            </div>
            <div class="qr-content-info">
              <div class="qr-content-info-price-info">
                应付金额：
                <span class="price-symbol">￥</span>
                <span class="price">{{ comboList[selectIndex].price }}</span>
              </div>
              <img
                class="qr-content-info-icon"
                src="@/assets/images/price-info-bak.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="members-buys" v-if="closeTwo">
      <div class="members-buys-body">
        <img
          class="members-buys-body-back"
          src="@/assets/images/font-back-icon.png"
        />
        <div class="qr-code-view">
          <div>
            <div class="qr-code">
              <div class="load-vessel" v-if="isLoad" @click="refresh">
                <div class="loading"></div>
              </div>
              <img class="qr-code-img" :src="url" />
            </div>
            <div class="qr-code-floter">
              <img class="qr-code-icon" src="@/assets/images/zfb-icon.png" />
              <img
                class="qr-code-icon"
                src="@/assets/images/accuracy-icon.png"
              />
              <span class="font-style">激活终身VIP</span>
            </div>
          </div>
        </div>
        <div class="qr-info">
          仅需<span style="font-size: 36px"
            >￥<template v-if="couponUsable">{{
              comboList[2].price - preferentialPrice
            }}</template
            ><template v-if="!couponUsable">{{ comboList[2].price }}</template>
          </span>
          <span style="text-decoration: line-through; margin: 0 10px"
            >原价￥{{ comboList[2].price }}</span
          >
          <div class="immediately">
            <img
              class="immediately-icon"
              src="@/assets/images/buttom-icon.png"
            />
            立减30
          </div>
        </div>
      </div>
      <div class="members-buys-tail">
        <div class="members-buys-tail-btn" @click="closeTowFun">关闭窗口</div>
      </div>
    </div>
  </div>
  <!-- end 会员购买 -->
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "MembersBuy",
  data() {
    return {
      // 套装列表
      comboList: [{}, {}, {}],
      // 选中
      selectIndex: 0,
      // 是否刷新
      isLoad: true,
      // 定时器
      timer: null,
      // 订单信息
      orderInfo: null,
      // 计时器
      timerCount: 0,
      // 关闭窗口1
      closeOne: true,
      // 关闭窗口1
      closeTwo: false,
      // 优惠价格
      preferentialPrice: 0,
      // 优惠劵是否可用
      couponUsable: false,
      url: "",
    };
  },
  props: {
    open: {
      typeof: Boolean,
      default: false,
    },
  },
  watch: {
    open: {
      handler(newVal) {
        if (newVal) {
          this.getPricePlan();
          this.closeOne = true;
          this.loadingCoupons();
        }
      },
    },
  },
  methods: {
    // 加载优惠劵
    loadingCoupons() {
      let data = {
        code: "typingpasswin6666CouponInternal",
      };
      this.$http({
        url: "https://api.360qnw.com/api/coupon-detail",
        method: "get",
        params: data,
      }).then(({ data }) => {
        if (data.code == 0) {
          this.preferentialPrice = data.data.price;
          if (data.data.status == 1) {
            this.couponUsable = true;
          }
        }
      });
    },
    // 关闭弹窗
    closeWindows() {
      this.closeOne = false;
      this.closeTwo = true;
      this.isLoad = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.createPayQr(this.comboList[2].id, true);
    },
    // 关闭窗口
    closeTowFun() {
      this.closeOne = true;
      this.closeTwo = false;
      this.isLoad = false;
      this.close();
    },
    // 获取价格版本
    getPricePlan() {
      let data = {
        soft_id: "typing_pass_win",
      };
      this.$http({
        url: "https://api.kuaixunda.cn/api/price_plan",
        method: "get",
        params: data,
      }).then(({ data }) => {
        this.comboList = data.data;
        this.selectCombo(0);
      });
    },
    //关闭弹窗
    close() {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.$emit("close");
    },
    // 刷新
    refresh() {
      this.createPayQr(this.comboList[this.selectIndex].id);
      this.isLoad = false;
    },
    // 防止点击
    preventClick() {},
    // 选中套餐
    selectCombo(key) {
      this.selectIndex = key;
      this.createPayQr(this.comboList[key].id);
    },
    jdugeTransPort() {
      return localStorage.getItem("transport");
    },
    // 生成支付吗
    createPayQr(goods_id, sign = false) {
      let token = localStorage.getItem("token");
      let data = {
        goods_id: goods_id,
        plan_type: 0,
        source: window.win_source(),
        source_soft_id: "typing_pass_win",
        token: token,
        uncache: 1,
      };
      if (sign && this.couponUsable) {
        data.coupon_code = "typingpasswin6666CouponInternal";
      }
      this.$http({
        url: "https://api.kuaixunda.cn/api/wechat-qr",
        method: "get",
        params: data,
      }).then(({ data }) => {
        if (data.code == 0) {
          if (this.jdugeTransPort()) {
            this.getDesktopPayCode();
            const orderData = data.data;
            const packageData = this.comboList[this.selectIndex];
            const wxUserInfo = JSON.parse(
              localStorage.getItem("wxUserInfo") || "{}"
            );
            const desktopParams = {
              cmd: 18,
              param: {
                wszOrderId: orderData.order_sn,
                dwAmount: orderData.price * 100,
                tOrderCreateTime:
                  parseInt((new Date().getTime() / 100).toString()) * 100,
                wszUserId: wxUserInfo.uid,
                wszProductId: packageData.id,
                wszProductDescription: packageData.plan_name,
              },
            };
            window.win_message(JSON.stringify(desktopParams));
            return;
          }
          this.orderInfo = data.data;
          this.url = data.data.url;
          this.getPayResultRoundRound(data.data.order_id);
        }
      });
    },
    // 获取支付结果轮巡
    getPayResultRoundRound(order_id) {
      if (this.timer != null) {
        clearTimeout(this.timer);
      }
      this.timerCount = 0;
      this.timer = setInterval(() => {
        //需要定时执行的代码
        this.getPayResult(order_id);
        this.timerCount++;
        if (this.timerCount * 2 >= 180) {
          clearTimeout(this.timer);
          this.isLoad = true;
        }
      }, 2000);
    },
    getDesktopPayCode() {
      let time = 60;
      const timer = setInterval(async () => {
        if (!time) {
          clearInterval(timer);
          this.isLoad = true;
          return;
        }
        time--;
        const userPayData = window.localStorage.getItem("userPay");
        if (!userPayData) return;
        const data = JSON.parse(userPayData);
        let imgUrl = "";
        if (data.cmd === 18) {
          if (imgUrl === data.url) return;
          imgUrl = data.url;
          try {
            const imgBase64 = await QRCode.toDataURL(data.url, {
              width: 300,
              height: 300,
              margin: 4,
            });
            this.url = imgBase64;
          } catch (e) {}
        } else if (data.cmd === 19) {
          if (data.status) {
            this.$emit("reloadVipInfo");
            if (this.closeOne) {
              this.close();
            } else {
              this.closeTowFun();
            }
          }
        }
        window.localStorage.removeItem("userPay");
      }, 2000);
    },
    // 获取支付结果
    getPayResult(order_id) {
      let data = {
        order_id: order_id,
      };
      this.$http({
        url: "https://api.kuaixunda.cn/api/verify-buy",
        method: "get",
        params: data,
      }).then(({ data }) => {
        if (data.code == 0 && data.data.status.code == 1) {
          clearTimeout(this.timer);
          this.$emit("reloadVipInfo");
          if (this.closeOne) {
            this.close();
          } else {
            this.closeTowFun();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .members-buys {
    width: 400px;
    height: 493px;
    background: linear-gradient(180deg, #ff854d 0%, #ff4d40 100%);
    border-radius: 10px 10px 0px 0px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1607843137254902);
    flex-direction: column;
    .members-buys-tail {
      width: 400px;
      height: 96px;
      background: #ffffff;
      border-radius: 0px 0px 10px 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .members-buys-tail-btn {
        width: 110px;
        height: 36px;
        background: #fb563a;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
    .members-buys-body {
      width: 400px;
      height: 397px;
      background: linear-gradient(180deg, #ff854d 0%, #ff4d40 100%);
      border-radius: 10px 10px 0px 0px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .members-buys-body-back {
        width: 327px;
        height: 46px;
        margin-top: 32px;
      }
      .qr-info {
        margin-top: 23px;
        font-size: 16px;
        color: #ffffff;
        font-weight: bold;
        position: relative;
        .immediately {
          position: absolute;
          width: 66px;
          height: 24px;
          background: #ffa43b;
          right: 10px;
          top: -10px;
          font-size: 12px;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          .immediately-icon {
            margin-right: 4px;
            padding-top: 4px;
            width: 10px;
            height: 13px;
          }
        }
      }
      .qr-code-view {
        margin-top: 16px;
        width: 190px;
        height: 210px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        .qr-code {
          width: 160px;
          height: 160px;
          position: relative;
          .qr-code-img {
            width: 100%;
            height: 100%;
          }
          .load-vessel {
            top: 0px;
            position: absolute;
            width: 100%;
            height: 100%;
            background: #000000;
            opacity: 0.9;
            display: flex;
            align-items: center;
            justify-content: center;
            .load-vessel-icon {
              width: 40px;
              height: 40px;
            }
          }
        }
        .qr-code-floter {
          display: flex;
          align-items: center;
          justify-content: center;
          .qr-code-icon {
            width: 22px;
            height: 20px;
            margin-right: 6px;
          }
          .font-style {
            margin-top: 6px;
            font-size: 14px;
            font-weight: bold;
            color: #ff4d40;
          }
        }
      }
    }
  }
  .members-buy {
    width: 830px;
    height: 566px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1607843137254902);
    flex-direction: column;
    .members-buy-header {
      width: 100%;
      height: 42px;
      background: #37394e;
      border-radius: 6px 6px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .members-buy-header-title {
        margin-left: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
      }
      .closed-container {
        width: 40px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 11px;
        .members-buy-header-close {
          width: 20px;
          height: 20px;
        }
      }
      .closed-container:hover {
        background-color: rgba(153, 148, 148, 0.2);
      }
    }
    .members-buy-header-activity {
      width: 100%;
      height: 38px;
      background: #cbe8ff;
      display: flex;
      align-items: center;
      .activity-label {
        margin-left: 18px;
        width: 86px;
        height: 24px;
        background: #498bfd;
        border-radius: 0px 4px 0px 4px;
        font-size: 13px;
        font-weight: bold;
        color: #ffe483;
        text-align: center;
        line-height: 24px;
      }
      .activity-title {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        color: #33383e;
      }
    }
    .members-buy-conent {
      flex: 1;
      display: flex;
      .members-buy-conent-left {
        width: 220px;
        height: 100%;
      }
      .members-buy-info {
        flex: 1;
        margin-top: 30px;
        flex-direction: column;
        .price-options {
          display: flex;
          justify-content: center;
          .select-combo-list {
            border: 1px solid #3088ff !important;
            .combo-list-bottom {
              background: #3088ff !important;
              color: #ffffff !important;
            }
          }
          .combo-list {
            width: 170px;
            height: 142px;
            background: #ffffff;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: relative;
            cursor: pointer;
            .combo-list-title {
              margin-top: 14px;
              font-size: 13px;
              font-weight: bold;
              color: #33383e;
            }
            .combo-list-price {
              margin-top: 3px;
              font-size: 34px;
              font-weight: bold;
              color: #3088ff;
            }
            .combo-list-hint {
              font-size: 13px;
              font-weight: 400;
              color: #7f8792;
            }
            .combo-list-bottom {
              position: absolute;
              bottom: 0px;
              // width: 100%;
              left: 0;
              right: 0;
              height: 27px;
              background: #deecfc;
              border-radius: 0px 0px 6px 6px;
              text-align: center;
              line-height: 27px;
              font-size: 13px;
              font-weight: 400;
              color: #3088ff;
            }
          }
          .defalut-combo-list {
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #e8eaec;
          }
          .combo-interval {
            margin-left: 20px;
          }
        }
      }
      .members-buy-hint {
        margin-top: 23px;
        margin-left: 30px;
        font-size: 12px;
        font-weight: 400;
        color: #33383e;
      }
      .qr-content {
        margin-top: 22px;
        margin-left: 30px;
        display: flex;
        .qr-content-info {
          margin-left: 18px;
          .qr-content-info-price-info {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            .price-symbol {
              font-size: 22px;
              font-weight: bold;
              color: #fb4d3d;
            }
            .price {
              font-size: 32px;
              font-weight: bold;
              color: #fb4d3d;
            }
          }
          .qr-content-info-icon {
            margin-top: 24px;
            width: 226px;
            height: 110px;
          }
        }
        .members-buy-scan-qr-codes {
          width: 148px;
          height: 180px;
          padding: 10px 9px;
          box-sizing: border-box;
          border: 1px solid #dedede;
          .qr-vessel {
            width: 130px;
            height: 130px;
            position: relative;
            cursor: pointer;
            .load-vessel {
              top: 0px;
              position: absolute;
              width: 100%;
              height: 100%;
              background: #000000;
              opacity: 0.9;
              display: flex;
              align-items: center;
              justify-content: center;
              .load-vessel-icon {
                width: 40px;
                height: 40px;
              }
            }
            .qr-vessel-icon {
              width: 100%;
              height: 100%;
            }
          }
          .qr-vessel-info {
            margin-top: 6px;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            .qr-vessel-info-icon {
              width: 23px;
              height: 23px;
            }
          }
        }
      }
    }
  }
}
</style>

